import { mapState } from 'vuex';
import { isAssetCandidateForTranscribe } from 'v/Story/Timeline/api/transcription';
import wtTranscribe from 'v/Transcribe/Transcribe.vue';

export default {
  computed: {
    ...mapState({
      transcriptions: (state) => state.story.transcriptions,
      enableVOSubtitles: (state) => state.story.enableVOSubtitles,
    }),

    isAssetCandidateForTranscribe() {
      return isAssetCandidateForTranscribe(this.$props.asset);
    },

    currentTranscript() {
      return this.transcriptions[this.$props.asset.metadata.assetUUID];
    },

    transcribing() {
      return (
        this.enableVOSubtitles &&
        /PROCESSING/.test(this.currentTranscript?.status)
      );
    },
  },

  methods: {
    $_onEditTranscript() {
      this.mixinShowViewInModal({
        type: 'custom',
        component: wtTranscribe,
        showCloseButton: false,
        closeOnEscape: true,
        wrapperClass: ['wt-transcribe-modal'],
        store: this.$store,
        componentPropsData: {
          opener: app.TRANSCRIPT_OPENER.LIGHTBOX_MENU,
          list: [
            {
              assetUUID: this.$props.asset.metadata.assetUUID,
              transcribeSubType: app.transcribeSubType.VIDEO,
              timeLimit: false, // {startTime: 0, endTime: 1},
            },
          ],
        },
      });
    },
  },
};
